import { defineStore } from "pinia"


const useSettingsStore = defineStore(
  'settings',
  {
    state: () => ({
      title: '',
    }),
    actions: {
     
    },
    persist: true,
  })

export default useSettingsStore
